var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "d-flex gap-2" },
    [
      _c(
        _setup.Button,
        {
          staticClass: "border",
          nativeOn: {
            click: function ($event) {
              return _setup.resetDisplayOrders.apply(null, arguments)
            },
          },
        },
        [_vm._v("Display orders")]
      ),
      _vm._v(" "),
      _c(
        _setup.Button,
        {
          staticClass: "border",
          nativeOn: {
            click: function ($event) {
              return _setup.resetFileUsage.apply(null, arguments)
            },
          },
        },
        [_vm._v("File usage")]
      ),
      _vm._v(" "),
      _setup.isAdmin
        ? _c(
            _setup.Button,
            {
              staticClass: "border",
              nativeOn: {
                click: function ($event) {
                  return _setup.purgeCache.apply(null, arguments)
                },
              },
            },
            [_vm._v("Purge cache")]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }